module.exports = __webpack_public_path__ + "media/images/home-latinadirtygirl2-c9f08bc5a0d66654dd91908daa321af1.jpg";